import * as types from './actionTypes';

export const setIsMobile = (value: boolean) => ({
    type: types.SET_IS_MOBILE,
    value
});

export const setIsTablet = (value: boolean) => ({
    type: types.SET_IS_TABLET,
    value
});
